// @flow
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Rodal from 'rodal';
import { Helmet } from 'react-helmet';

import '../../assets/styles/modal.css';
import style from '../../assets/styles/modal.scss';

import type { Node } from 'react';

type Props = {
  +open: boolean;
  +width?: number;
  +height?: number;
  +handleClose: () => any;
  +closeOnEsc?: boolean;
  +children?: Node;
  +transparent?: boolean;
  +showCloseButton?: boolean;
  +singleElementMode?: boolean;
  +maskColor: MaskColor;
  +big?: boolean;
  +noPadding?: boolean;
  +gray?: boolean;
};

type MaskColor = $Keys<typeof colors>;

const DEFAULT_HEIGHT = 250;
const DEFAULT_WIDTH = 450;

const colors = {
  black: 'rgba(0, 0, 0, 0.5)',
  white: 'rgba(255, 255, 255, 0.90)',
};

export default class Modal extends Component<Props, void> {
  static defaultProps = {
    open: false,
    height: DEFAULT_HEIGHT,
    width: DEFAULT_WIDTH,
    closeOnEsc: false,
    showCloseButton: true,
    maskColor: 'black',
  };

  render() {
    const {
      open, height, width, handleClose, children, closeOnEsc, transparent, singleElementMode, showCloseButton,
      maskColor, big, noPadding, gray,
    } = this.props;
    return [
      open && <Helmet key="helmet">
        <style type="text/css">{`
          body {
              overflow: hidden!important;
          }
        `}</style>
      </Helmet>,
      <Rodal key="modal"
             visible={open}
             duration={120}
             customStyles={{ minHeight: height, height: 'auto', borderRadius: '5px' }}
             customMaskStyles={{ background: colors[maskColor] }}
             className={classNames({
               transparent: !!transparent,
               singleElementMode: !!singleElementMode,
               big: !!big,
               noPadding: !!noPadding,
               gray: !!gray,
             })}
             width={width}
             closeOnEsc={closeOnEsc}
             onClose={handleClose}
             showCloseButton={showCloseButton}>
        {children}
      </Rodal>
    ];
  }
}

Modal.propTypes = {
  open: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  handleClose: PropTypes.func.isRequired,
  closeOnEsc: PropTypes.bool,
  transparent: PropTypes.bool,
  singleElementMode: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  maskColor: PropTypes.string.isRequired,
  big: PropTypes.bool,
  noPadding: PropTypes.bool,
  gray: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/Modal/Modal.jsx